/* eslint-disabled */
import Insurer from "./Insurer";
import Branch from "./Branch";
import EngineMethod from "./EngineMethod";
import Avenant from "./Avenant";
import AvenantTypeExtend from "@/entity/extends/AvenantTypeExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class AvenantType extends AvenantTypeExtend {

    public id!: number;
    public label = '';
    public code = '';
    public description? = '';
    public insurers: Array<Insurer> = [];
    public branches: Array<Branch> = [];
    public isUpdatingPremium?: boolean;
    public preUpdateFunction!: EngineMethod;
    public calculationFunction!: EngineMethod;
    public allowAdd!: boolean;
    public allowRemove!: boolean;
    public allowEdit!: boolean;
    public allowStateUpdate?: boolean;
    public nextAvenantAllowed= [];
    public newStatus? = '';
    public allowContractCreation?: boolean;
    public allowedAddition= [];
    public allowedRemove= [];
    public allowedEdition= [];
    public avenants: Array<Avenant> = [];
    public icon? = '';
    public publicName? = '';
    public isPublic?: boolean;
    public color? = '';
    public workflows= [];
    public minEffect? = '';
    public maxEffect? = '';
    public allowNegativePremium?: boolean;
    public maxDurationDays?: number;
    public closure_mode? = '';
    public allowStartUpdate?: boolean;
    public allowEndUpdate?: boolean;

    constructor (object?: any) {
        super(object)
        if(object){
            this.id= object.id;
            this.label= object.label;
            this.code= object.code;
            this.description= object.description;
            hydrateCollection(object.insurers, Insurer, this.insurers);
            hydrateCollection(object.branches, Branch, this.branches);
            this.isUpdatingPremium= object.isUpdatingPremium;
            this.preUpdateFunction = (object.preUpdateFunction instanceof EngineMethod) ? object.preUpdateFunction : object.preUpdateFunction ? new EngineMethod(object.preUpdateFunction) : object.preUpdateFunction;
            this.calculationFunction = (object.calculationFunction instanceof EngineMethod) ? object.calculationFunction : object.calculationFunction ? new EngineMethod(object.calculationFunction) : object.calculationFunction;
            this.allowAdd= object.allowAdd;
            this.allowRemove= object.allowRemove;
            this.allowEdit= object.allowEdit;
            this.allowStateUpdate= object.allowStateUpdate;
            this.nextAvenantAllowed= object.nextAvenantAllowed;
            this.newStatus= object.newStatus;
            this.allowContractCreation= object.allowContractCreation;
            this.allowedAddition= object.allowedAddition;
            this.allowedRemove= object.allowedRemove;
            this.allowedEdition= object.allowedEdition;
            hydrateCollection(object.avenants, Avenant, this.avenants);
            this.icon= object.icon;
            this.publicName= object.publicName;
            this.isPublic= object.isPublic;
            this.color= object.color;
            this.workflows= object.workflows;
            this.minEffect= object.minEffect;
            this.maxEffect= object.maxEffect;
            this.allowNegativePremium= object.allowNegativePremium;
            this.maxDurationDays= object.maxDurationDays;
            this.closure_mode= object.closure_mode;
            this.allowStartUpdate= object.allowStartUpdate;
            this.allowEndUpdate= object.allowEndUpdate;
        }
        this.postConstruct()
    }

}
